import React, { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';

import { AllowedPaymentMethodConfig } from '@/modules/employer/types';

import PaymentMethodField from './PaymentMethodField';

const useDefaultPaymentForm = (
  addPaymentMethod: () => void,
  allowedPaymentMethodConfigs?: AllowedPaymentMethodConfig[]
) =>
  useMemo<Field[]>(
    () => [
      {
        name: 'paymentMethod',
        type: FieldTypes.Node,
        testId: 'paymentMethod',
        label: 'Default payment method',
        isThinMode: true,
        placeholder: 'Default payment method',
        value: (
          <PaymentMethodField
            onAdd={addPaymentMethod}
            allowedPaymentMethodConfigs={allowedPaymentMethodConfigs}
          />
        ),
      },
    ],
    [addPaymentMethod, allowedPaymentMethodConfigs]
  );

export default useDefaultPaymentForm;
